import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import Login from '../pages/login';
import RecuperarSenha from '../pages/RecuperarSenha';
import Configuracoes from '../pages/configuracoes';
import Perfil from '../pages/Perfil';

import Relatorios from '../pages/relatorios';
import CadastroFamilia from '../pages/CadastroFamilia';
// import CadastroPropriedade from '../pages/CadastroPropriedade';
import AdminLayout from '../layouts/AdminLayout';
import ProtectedRoute from '../components/ProtectedRoute';
import CadastroPovoado from '../pages/CadastroPovoado';
import CadastroUsuario from '../pages/CadastroUsuario';

import CadastroVisita from '../pages/CadastroVisita';
import CadastroRegiaoCultura from '../pages/CadastroRegiaoCultura';
import Consultar from '../pages/consultar';


export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/Login" element={<Login />} />
      <Route path="/RecuperarSenha" element={<RecuperarSenha />} />
      <Route path="/" element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="/Configuracoes" element={<Configuracoes />} />
        <Route path="/Configuracoes/Perfil" element={<Perfil />} />
        <Route path="/Relatorios" element={<Relatorios />} />
        <Route path="/Consultar" element={<Consultar />} />
        <Route path="/CadastroFamilia" element={<CadastroFamilia />} />
        <Route path="/CadastroUsuario" element={<CadastroUsuario />} />
        {/* <Route path="/CadastroPropriedade" element={<CadastroPropriedade />} /> */}
        <Route path="/CadastroPovoado" element={<CadastroPovoado />} />
        <Route path="/CadastroRegiaoCultura" element={<CadastroRegiaoCultura />} />
        <Route path="/CadastroVisita" element={<CadastroVisita />} />
      </Route>
      
    </Routes>
  );

}

